module.exports = __webpack_public_path__ + "static/media/signup-right-ellipse.3b396895.png";